import styled from 'styled-components';

export const Wrapper = styled.button`
  align-items: center;
  background-color: rgba(0, 0, 0, 0);
  border-radius: 2px;
  border: 1px solid #e4eaf4;
  box-shadow: none;
  color: #244696;
  cursor: pointer;
  display: inline-flex;
  font-size: 14px;
  line-height: 1;
  padding: 15px 16px;
  transition: opacity 0.3s;

  &:hover,
  &:active {
    opacity: 0.7;
  }

  svg {
    stroke: currentColor;
  }
`;

export const Content = styled.span`
  svg + & {
    margin-left: 10px;
  }

  & + svg {
    margin-left: 10px;
  }
`;
